import { darken } from 'polished';
import { styled } from 'styled-components';

export const Container = styled.button`
  width: 100%;

  hr {
    margin: 1rem 0 0;
  }
`;

export const HeaderCard = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;

  svg {
    width: 1rem;
    color: ${({ theme }) => theme.colors.blue03.color};
  }
`;

export const Content = styled.div`
  margin: 0.8rem 0.1rem;

  p {
    margin: 0;
  }
`;

export const FooterCard = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding-top: 0.7rem;

  .chakra-avatar {
    background-color: ${({ theme }) => darken(0.1, theme.colors.light.color)};
    border: 1px solid ${({ theme }) => theme.colors.white};
    box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.05);

    div {
      color: ${({ theme }) => theme.colors.dark.color};
      font-weight: bold;
    }
  }

  p {
    flex: 1;
    text-align: right;
  }
`;

export const BoxTable = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.texts_light};
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.texts_light};
  line-height: 1;
  padding: 8px 10px;
`;
